export const siteSettings = {
  name: "Multi Chain Markets",
  link: "https://multimarkets.live",
  email: "support@multimarkets.live",
  appLink: "https://app.multimarkets.live",
};
